/**
 * QnaThreadStatusBadge — the status chip for one Rückfragen thread (P2 Placement Slice 9, Tab 3c):
 * offen -> warning, erledigt -> success; plus a danger «Antwort ueberfaellig» badge when overdue and an
 * info «n ungelesen» count when there are unread questions.
 */

import { Badge } from '../../components/ui/Badge';
import { QNA_THREAD_STATUS, QNA_THREAD_STATUS_LABELS, QNA_UEBERFAELLIG_LABEL } from '@brokly/shared';
import type { QnaThreadStatus } from '@brokly/shared';

type BadgeVariant = 'neutral' | 'outline' | 'success' | 'warning' | 'danger' | 'info';

const VARIANT_BY_STATUS: Record<QnaThreadStatus, BadgeVariant> = {
  [QNA_THREAD_STATUS.OFFEN]: 'warning',
  [QNA_THREAD_STATUS.ERLEDIGT]: 'success',
};

export function QnaThreadStatusBadge({
  status,
  ueberfaellig,
  ungelesen,
}: {
  status: QnaThreadStatus;
  ueberfaellig: boolean;
  ungelesen: number;
}) {
  return (
    <span className="inline-flex items-center gap-1" data-testid="qna-status-badge">
      <Badge variant={VARIANT_BY_STATUS[status]}>{QNA_THREAD_STATUS_LABELS[status]}</Badge>
      {ueberfaellig && <Badge variant="danger">{QNA_UEBERFAELLIG_LABEL}</Badge>}
      {ungelesen > 0 && <Badge variant="info">{ungelesen} ungelesen</Badge>}
    </span>
  );
}
